import routes from 'utils/routes';

function useRoutes() {
  return routes();
}

export default useRoutes;
